import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LayoutDashboard, Calendar, FileText, Users, Image as ImageIcon, Settings, LogOut, Camera, FileArchive, Building2, MessageCircle, Images } from 'lucide-react';
import { clsx } from 'clsx';

export default function AdminLayout() {
  const { logout } = useAuth();
  const location = useLocation();

  const navItems = [
    { name: 'Dashboard', path: '/admin/dashboard', icon: LayoutDashboard },
    { name: 'Randevular', path: '/admin/appointments', icon: Calendar },
    { name: 'Kurumsal/Hakkımızda', path: '/admin/corporate', icon: Building2 },
    { name: 'Tedaviler', path: '/admin/treatments', icon: FileText },
    { name: 'Hekimler', path: '/admin/team', icon: Users },
    { name: 'Slider & Banner', path: '/admin/slider', icon: ImageIcon },
    { name: 'Kayar Galeri', path: '/admin/gallery', icon: Images },
    { name: 'Öncesi/Sonrası', path: '/admin/before-after', icon: Camera },
    { name: 'Hasta Yorumları', path: '/admin/testimonials', icon: MessageCircle },
    { name: 'Bloglar', path: '/admin/blogs', icon: FileArchive },
    { name: 'Ayarlar', path: '/admin/settings', icon: Settings },
  ];

  return (
    <div className="flex h-screen bg-slate-50">
      <aside className="w-64 bg-white border-r border-slate-200 flex flex-col">
        <div className="p-6 border-b border-slate-100 flex items-center gap-3">
          <img src="https://customer-assets.emergentagent.com/job_dentakron-dental/artifacts/k9vx59de_123.png" alt="Logo" className="h-10" />
        </div>
        <nav className="flex-1 p-4 space-y-1 overflow-y-auto custom-scrollbar">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={clsx(
                "flex items-center gap-3 px-4 py-3 rounded-xl transition-colors text-sm font-medium",
                location.pathname === item.path 
                  ? "bg-primary/10 text-primary" 
                  : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
              )}
            >
              <item.icon className="w-5 h-5 flex-shrink-0" />
              {item.name}
            </Link>
          ))}
        </nav>
        <div className="p-4 border-t border-slate-100">
          <button 
            onClick={logout}
            className="flex items-center gap-3 px-4 py-3 w-full rounded-xl text-slate-600 hover:bg-red-50 hover:text-red-600 transition-colors text-sm font-medium"
          >
            <LogOut className="w-5 h-5 flex-shrink-0" />
            Çıkış Yap
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-y-auto bg-slate-50/50">
        <div className="p-8 max-w-7xl mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
